<script>
	// import * as pluralize from 'pluralize';
	import pluralize from 'pluralize';
	/** @type {any} id */
	export let id = null;
	/** @type {String} title */
	export let title = '';
	/** @type {String} section */
	export let section = '';
	/** @type {String} abstract */
	export let abstract = '';
	/** @type {Array<Object>} [authors] */
	export let authors = [];
	/** @type {String} scopus_id */
	export let scopus_id = '';
	/** @type {String} wikidata_id */
	export let wikidata_id = '';
	/** @type {Boolean} draft */
	export let draft = false;
	/** @type {Boolean} abstract_only */
	export let abstract_only = false;
	export let doi = '';
	import AuthorsList from '$lib/components/shared/AuthorsList.svelte';
	import DisplayIds from '$lib/components/shared/DisplayIds.svelte';
</script>

<div class="py-12 bg-gray-200 sm:py-22">
	<div class="px-6 mx-auto max-w-7xl lg:px-8">
		<div class="max-w-5xl mx-auto lg:mx-0">
			<p class="text-base font-semibold leading-7 text-orange-600">{pluralize.singular(section)}</p>
			<h2 class="mt-2 text-3xl font-normal tracking-tight text-gray-900 sm:text-4xl">{title}</h2>
			<AuthorsList {authors} />

			{#if !abstract_only}
				<!-- Add a PDF download Button -->
				<span class="inline-flex rounded-md shadow-sm isolate">
					<a
						href="/files/articles/{id}/dcmi-{id}.pdf"
						class="relative inline-flex items-center gap-x-1.5 rounded-l-md bg-white px-3 py-2 text-sm font-medium text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
						download="dcmi-{id}.pdf"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="1.5"
							stroke="currentColor"
							class="-ml-0.5 h-5 w-5 text-gray-400"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
							/>
						</svg>

						Download PDF
					</a>
					<a
						href="https://dcpapers.dublincore.org/read/?article={id}"
						target="_blank"
						class="relative inline-flex items-center gap-x-1.5 rounded-r-md -ml-px bg-white px-3 py-2 text-sm font-medium text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
						rel="external noindex nofollow"
						data-sveltekit-preload-data="false"
						data-sveltekit-reload
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="1.5"
							stroke="currentColor"
							class="-ml-0.5 h-5 w-5 text-gray-400"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
							/>
						</svg>

						Read Online
					</a>
				</span>
			{/if}

			<DisplayIds {scopus_id} {wikidata_id} />

			{#if doi}
				<div class="mt-6 text-base leading-7 text-blue-700">
					<a
						href={`https://doi.org/${doi}`}
						class="text-blue-700 hover:underline"
						target="_blank"
						rel="noopener noreferrer"
					>
					</a>
				</div>
			{/if}
		</div>
	</div>
</div>

<!-- if article.scopus_id -->
